import './Theme.Page.Centered.scss';
export default `ThemePageCentered`;
